<template>
	<panel showback title='我的订单' class="user-order-list">
		<van-dropdown-menu class="menu">
			<van-dropdown-item v-model="data.appId" :options="app_list" @change='data.reload' />
			<van-dropdown-item v-model="data.categoryCode" :options="category_list" @change='handle_category' />
			<van-dropdown-item v-model="data.orderstatus" :options="orderstatus_list" @change='data.reload' />
			<van-dropdown-item v-model="data.status" :options="status_list" @change='data.reload' />
		</van-dropdown-menu>
		<div class="p-10 h100" v-vuet-scroll='{ path: "root/order/list", name: "default" }'>
			<van-pull-refresh v-model="data.loading" @refresh="data.reload">
				<van-list v-model="data.loading" :finished="data.loaded" finished-text="没有更多了" @load="data.select" :error-text='data.error'>
					<list-item :appobj='appobj' :configobj='configobj' v-for="(item, index) in data.list" :key="item.id" :item="item" :showedit="showedit" @click="$router.push(`/user/group/edit/${item.id}`)" @del="del(item, index)"></list-item>
				</van-list>
			</van-pull-refresh>
		</div>
	</panel>
</template>
<script>
	import { mapModules, mapRules } from "vuet";
	import listiem from "@/components/page/listitem/order.vue";
	import { order_status } from "@/util/config/data.js";
	export default {
		mixins: [
			mapModules({
				data: "root/order/list",
				app: "root/app",
			}),
			mapRules({
				router: "root/order/list",
				once: "root/app",
			}),
		],
		components: {
			"list-item": listiem,
		},
		data() {
			var slist = [];
			for (var k in order_status) {
				slist.push({
					text: order_status[k],
					value: k,
				});
			}
			return {
				status_list: [{ text: "订单状态", value: "" }, ...slist],
			};
		},
		computed: {
			app_list() {
				var list = [{ text: "全部应用", value: "" }];
				this.app.apps.forEach((item) => {
					list.push({
						text: item.name,
						value: item.id,
					});
				});
				return list;
			},
			category_list() {
				var list = [{ text: "订单类型", value: "" }];

				this.app.configs
					.filter((x) => x.type == "order")
					.forEach((item) => {
						list.push({
							text: item.name,
							value: item.code,
						});
					});
				return list;
			},
			orderstatus_list() {
				var categoryid = 0;
				if (this.data.categoryCode) {
					var item = this.app.configs.find(
						(x) => x.code == this.data.categoryCode
					);
					if (item) {
						categoryid = item.id;
					}
				}
				var list = [{ text: "业务状态", value: "" }];
				this.app.configitems.forEach((item) => {
					if (categoryid) {
						if (item.configId == categoryid) {
							list.push({
								text: item.name,
								value: item.value,
							});
						}
					} else {
						list.push({
							text: item.name,
							value: item.value,
						});
					}
				});
				return list;
			},
			configobj() {
				var obj = {};
				this.app.configitems.forEach((item) => {
					if (!obj[item.configId]) {
						obj[item.configId] = [];
					}
					obj[item.configId].push(item);
				});
				return obj;
			},
			appobj() {
				var obj = {};
				this.app.apps.forEach((item) => {
					obj[item.id] = item;
				});
				return obj;
			},
		},
		methods: {
			handle_category() {
				this.data.orderstatus = "";
				this.data.reload();
			},
		},
		mounted() {},
	};
</script>
<style lang='less'>
.user-order-list {
	padding-top: 92px;

	.h100 {
		height: 100%;
		overflow-y: auto;
	}

	.menu {
		position: absolute;
		top: 46px;
		left: 0px;
		width: 100%;
	}
}
</style>